<template>
    <div :class="['input-wrapper form-input-upload-file input-has-full-dash-border', {'has-error': hasError}]">
        <div :class="[{'has-files': hasFiles}]">
            <input type="file" :id="name" :name="name" multiple :accept="allowedFiles">
        </div>

        <v-button 
            v-if="hasFiles" 
            :label="__('Add another file')" 
            @onClick="chooseFile" 
            variant="secondary" 
            size="sm" 
            position="right"
            icon="material-symbols-rounded.add"
        ></v-button>

        <div v-else class="choose-file-wrapper">
            <div v-if="name === 'confirmation_of_diagnosis'">
                <p class="choose-file-text"><strong>Rezept oder Diagnosenachweis hochladen</strong> (Foto oder Scan)</p>
                <div class="popup">
                    <span class="popup-icon">
                        <svg width="24" height="26" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.4 26.3L11.9667 26.2667C8.67778 25.8889 5.93333 24.4889 3.73333 22.0667C1.55556 19.6222 0.466667 16.7444 0.466667 13.4333C0.466667 9.85555 1.71111 6.83333 4.2 4.36666C6.71111 1.87778 9.75556 0.633331 13.3333 0.633331C15.1111 0.633331 16.7778 0.977776 18.3333 1.66667C19.8889 2.33333 21.2444 3.25555 22.4 4.43333C23.5778 5.58889 24.5 6.94444 25.1667 8.5C25.8556 10.0556 26.2 11.7222 26.2 13.5C26.2 16.9889 25.1667 20.0889 23.1 22.8C21.0333 25.4889 18.4778 27.7667 15.4333 29.6333C15.1 29.8111 14.7556 29.9 14.4 29.9C14.0667 29.8778 13.7444 29.7778 13.4333 29.6C13.1222 29.4222 12.8778 29.1889 12.7 28.9C12.5222 28.5889 12.4333 28.2444 12.4333 27.8667L12.4 26.3ZM13.3333 21.1333C13.8444 21.1333 14.2667 20.9667 14.6 20.6333C14.9556 20.2778 15.1333 19.8444 15.1333 19.3333C15.1333 18.8222 14.9556 18.4 14.6 18.0667C14.2667 17.7111 13.8444 17.5333 13.3333 17.5333C12.8222 17.5333 12.3889 17.7111 12.0333 18.0667C11.7 18.4 11.5333 18.8222 11.5333 19.3333C11.5333 19.8444 11.7 20.2778 12.0333 20.6333C12.3889 20.9667 12.8222 21.1333 13.3333 21.1333ZM10.2667 10.8333C10.6222 10.9667 10.9667 10.9667 11.3 10.8333C11.6556 10.7 11.9556 10.4778 12.2 10.1667C12.3778 9.96667 12.5556 9.82222 12.7333 9.73333C12.9333 9.62222 13.1556 9.56667 13.4 9.56667C13.7778 9.56667 14.0889 9.67778 14.3333 9.9C14.6 10.1222 14.7333 10.3889 14.7333 10.7C14.7333 10.9667 14.6444 11.2556 14.4667 11.5667C14.2889 11.8778 14.0444 12.1778 13.7333 12.4667C13.2222 12.9333 12.8 13.4222 12.4667 13.9333C12.1333 14.4444 11.9667 14.8889 11.9667 15.2667C11.9667 15.6444 12.0889 15.9667 12.3333 16.2333C12.6 16.4778 12.9222 16.6 13.3 16.6C13.6111 16.6 13.8889 16.5 14.1333 16.3C14.3778 16.0778 14.5889 15.8222 14.7667 15.5333C14.9444 15.2 15.1333 14.8889 15.3333 14.6C15.5333 14.3111 15.7222 14.0778 15.9 13.9C16.5444 13.1889 16.9889 12.6 17.2333 12.1333C17.4778 11.6667 17.6 11.1444 17.6 10.5667C17.6 9.43333 17.2333 8.53333 16.5 7.86666C15.7889 7.2 14.8333 6.86666 13.6333 6.86666C12.8111 6.86666 12.0556 7.03333 11.3667 7.36666C10.6778 7.7 10.1556 8.14444 9.8 8.7C9.55556 9.1 9.46667 9.52222 9.53333 9.96667C9.62222 10.3889 9.86667 10.6778 10.2667 10.8333Z" fill="#5937B7"/>
                        </svg>
                    </span>

                    <div class="popup-wrapper">
                        <p class="new-text-lg"><strong>Als Diagnosenachweis gilt jedes Dokument, aus dem hervorgeht, dass bei Ihnen Diabetes Typ 2 diagnostiziert wurde, z.B.</strong></p>

                        <ul class="list-w-check">
                            <li>
                                <figure>
                                    <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                        <span>check</span>
                                    </span>
                                </figure>
                                <span class="new-text-md">Arztbrief</span>
                            </li>
                            <li>
                                <figure>
                                    <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                        <span>check</span>
                                    </span>
                                </figure>
                                <span class="new-text-md">Diabetespass</span>
                            </li>
                            <li>
                                <figure>
                                    <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                        <span>check</span>
                                    </span>
                                </figure>
                                <span class="new-text-md">Überweisungsschein</span>
                            </li>
                            <li>
                                <figure>
                                    <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                        <span>check</span>
                                    </span>
                                </figure>
                                <span class="new-text-md">Medikamentenplan</span>
                            </li>
                            <li>
                                <figure>
                                    <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                        <span>check</span>
                                    </span>
                                </figure>
                                <span class="new-text-md">Befundbericht</span>
                            </li>
                            <li>
                                <figure>
                                    <span class="material-symbols-rounded full-circle icon-check-list text-green">
                                        <span>check</span>
                                    </span>
                                </figure>
                                <span class="new-text-md">AU</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <p v-else class="choose-file-text text-bold" v-html="label"></p>
            <v-button :label="__('Select a file')" variant="secondary" size="sm" position="right" @onClick="chooseFile"></v-button>
        </div>

        <form-input-error v-if="hasError" :error="inputErrors[0]"></form-input-error>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                type: Array,
                required: false,
                default: null
            },
            name: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            maxFilesCount: {
                type: Number,
                required: false,
                default: 0
            },
            allowedFiles: {
                type: Array,
                required: false,
                default: null
            }
        },

        data() {
            return {
                hasFiles: false,
                files: [],
                hasError: false,
                inputErrors: this.errors
            }
        },

        watch: {
            inputErrors: {
                immediate: true,
                handler(errors) {
                    if (errors === null || errors === undefined || errors.length === 0) {
                        this.hasError = false
                    } else {
                        this.hasError = true
                    }
                }
            },
            errors: {
                immediate: true,
                handler(errors) {
                    this.inputErrors = errors
                }
            }
        },

        mounted() {
            var that = this

            setTimeout(() => {
                $(`#${this.name}`).fileinput({
                    showZoom: false,
                    showUpload: false,
                    showCancel: false,
                    showRemove: true,
                    showCaption: false,
                    dropZoneEnabled: false,
                    retryErrorUploads: false,
                    removeFromPreviewOnError: true,
                    showUploadedThumbs: false,
                    hideThumbnailContent: true,
                    uploadUrl: '/site/test-upload',
                    language: _.get(window, 'locale', 'cs'),
                    maxFileSize: 10000,
                    maxTotalFileCount: that.maxFilesCount,
                    elErrorContainer: '',
                    layoutTemplates: {
                        main1:
                            '{preview}\n' +
                            '<div class="kv-upload-progress kv-hidden"></div><div class="clearfix"></div>\n' +
                            '<div class="input-group {class}">\n' +
                            '  {caption}\n' +
                            '</div>',
                        main2:
                            '{preview}\n<div class="kv-upload-progress hide"></div>',
                        size: '<samp>{sizeText}</samp>',
                        actions:
                            '<div class="file-actions">\n' +
                            '    <div class="file-footer-buttons">\n' +
                            '        {delete}' +
                            '    </div>\n' +
                            '    <div class="clearfix"></div>\n' +
                            '</div>',
                        preview:
                            '<div class="file-preview {class}">\n' +
                            '    <div class="{dropClass}">\n' +
                            '    <div class="file-preview-thumbnails">\n' +
                            '    </div>\n' +
                            '    <div class="clearfix"></div>' +
                            '    <div class="kv-fileinput-error"></div>\n' +
                            '    </div>\n' +
                            '</div>',
                        actionDelete: '<button type="button" class="kv-file-remove" title="{removeTitle}"{dataUrl}{dataKey} aria-label="Remove file"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 9.0625L10.4167 11.4792C10.5694 11.6319 10.7431 11.7083 10.9375 11.7083C11.1458 11.6944 11.3264 11.6111 11.4792 11.4583C11.6319 11.3056 11.7083 11.1319 11.7083 10.9375C11.7083 10.7292 11.6319 10.5486 11.4792 10.3958L9.0625 7.97917L11.4792 5.58333C11.6319 5.43056 11.7083 5.25694 11.7083 5.0625C11.7083 4.85417 11.6319 4.67361 11.4792 4.52083C11.3264 4.36805 11.1458 4.29167 10.9375 4.29167C10.7431 4.29167 10.5694 4.36805 10.4167 4.52083L8 6.9375L5.58333 4.52083C5.43056 4.36805 5.25694 4.29167 5.0625 4.29167C4.86806 4.29167 4.69444 4.36805 4.54167 4.52083C4.38889 4.67361 4.3125 4.85417 4.3125 5.0625C4.3125 5.25694 4.38889 5.43056 4.54167 5.58333L6.9375 8L4.52083 10.4167C4.36806 10.5694 4.29167 10.7431 4.29167 10.9375C4.30556 11.1319 4.38889 11.3056 4.54167 11.4583C4.69444 11.6111 4.86806 11.6875 5.0625 11.6875C5.27083 11.6875 5.45139 11.6111 5.60417 11.4583L8 9.0625ZM8 16C6.90278 16 5.86806 15.7917 4.89583 15.375C3.92361 14.9583 3.06944 14.3889 2.33333 13.6667C1.61111 12.9306 1.04167 12.0764 0.625 11.1042C0.208334 10.1319 1.78814e-07 9.09722 1.78814e-07 8C1.78814e-07 6.88889 0.208334 5.85417 0.625 4.89583C1.04167 3.92361 1.61111 3.07639 2.33333 2.35417C3.06944 1.61805 3.92361 1.04167 4.89583 0.624999C5.86806 0.208333 6.90278 -7.15256e-07 8 -7.15256e-07C9.11111 -7.15256e-07 10.1458 0.208333 11.1042 0.624999C12.0764 1.04167 12.9236 1.61805 13.6458 2.35417C14.3819 3.07639 14.9583 3.92361 15.375 4.89583C15.7917 5.85417 16 6.88889 16 8C16 9.09722 15.7917 10.1319 15.375 11.1042C14.9583 12.0764 14.3819 12.9306 13.6458 13.6667C12.9236 14.3889 12.0764 14.9583 11.1042 15.375C10.1458 15.7917 9.11111 16 8 16ZM8 14.5C9.80556 14.5 11.3403 13.8681 12.6042 12.6042C13.8681 11.3403 14.5 9.80556 14.5 8C14.5 6.19444 13.8681 4.65972 12.6042 3.39583C11.3403 2.13194 9.80556 1.5 8 1.5C6.19444 1.5 4.65972 2.13194 3.39583 3.39583C2.13194 4.65972 1.5 6.19444 1.5 8C1.5 9.80556 2.13194 11.3403 3.39583 12.6042C4.65972 13.8681 6.19444 14.5 8 14.5Z" fill="#FF3E57"/></svg></button>\n',
                        btnBrowse:
                            '<div tabindex="500" class="{css}"{status}><svg width="28px" height="25px" viewBox="0 0 28 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Android-APP-wireframes" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="4" transform="translate(-296.000000, -521.000000)" fill="#FFFFFF" fill-rule="nonzero"> <g id="Button/Primary/New-Photo" transform="translate(280.000000, 504.000000)"> <path d="M44,23.25 L44,39.3214286 C44,40.8002232 42.8242188,42 41.375,42 L18.625,42 C17.1757812,42 16,40.8002232 16,39.3214286 L16,23.25 C16,21.7712054 17.1757812,20.5714286 18.625,20.5714286 L23.4375,20.5714286 L24.1101563,18.7354911 C24.4929688,17.6919643 25.471875,17 26.565625,17 L33.4289063,17 C34.5226563,17 35.5015625,17.6919643 35.884375,18.7354911 L36.5625,20.5714286 L41.375,20.5714286 C42.8242188,20.5714286 44,21.7712054 44,23.25 Z M36.5625,31.2857143 C36.5625,27.5915179 33.6203125,24.5892857 30,24.5892857 C26.3796875,24.5892857 23.4375,27.5915179 23.4375,31.2857143 C23.4375,34.9799107 26.3796875,37.9821429 30,37.9821429 C33.6203125,37.9821429 36.5625,34.9799107 36.5625,31.2857143 Z M34.8125,31.2857143 C34.8125,33.9921875 32.6523438,36.1964286 30,36.1964286 C27.3476562,36.1964286 25.1875,33.9921875 25.1875,31.2857143 C25.1875,28.5792411 27.3476562,26.375 30,26.375 C32.6523438,26.375 34.8125,28.5792411 34.8125,31.2857143 Z" id="foto"></path> </g> </g> </g> </svg></div>'
                    }
                })
                .on('fileselect', function() {
                    that.setFiles()         
                })
                .on('fileremoved', function() {
                    that.setFiles()     
                })
                .on('fileuploaderror', function(event, data, msg) {
                    setTimeout(() => {
                        that.inputErrors = [msg]
                    }, 10);
                });
            }, 100)
        },

        methods: {
            chooseFile() {
                $(`#${this.name}`).click()
            },
            fileListItems(files) {
                const b = new ClipboardEvent('').clipboardData || new DataTransfer()

                for (let i = 0, len = files.length; i < len; i++) {
                    b.items.add(files[i])
                }

                return b.files
            },
            setFiles() {
                this.inputErrors = [];
                const selectedFiles = $(`#${this.name}`).fileinput('getFileList');
                let updatedFileList = []

                if (selectedFiles && selectedFiles.length > 0) {
                    updatedFileList = this.fileListItems(selectedFiles);
                    this.files = updatedFileList;
                    document.getElementById(this.name).files = updatedFileList;
                    this.hasFiles = true;
                } else {
                    this.files = null;
                    this.hasFiles = false;
                }

                this.$forceUpdate();
            }
        }
    }
</script>
